import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, ExternalLink } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="footer-form" className="bg-gradient-to-t from-black to-dark-200 border-t border-gray-800">
      <div className="container mx-auto px-6 py-12">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <Link to="/" className="text-2xl font-bold text-white hover:text-brand transition-colors">
              Mike Foto
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed max-w-sm">
              Digital στρατηγική και ανάπτυξη επιχειρήσεων online. Γρήγορα, καθαρά, αποτελεσματικά.
            </p>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-white font-semibold text-lg">Επικοινωνία</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3 text-gray-400 hover:text-white transition-colors">
                <MapPin className="w-4 h-4 text-brand" />
                <span className="text-sm">Πλατεία Δημοκρατίας 5, Θεσσαλονίκη</span>
              </div>
              <a 
                href="tel:+306986904312" 
                className="flex items-center space-x-3 text-gray-400 hover:text-white transition-colors"
              >
                <Phone className="w-4 h-4 text-brand" />
                <span className="text-sm">+30 698 690 4312</span>
              </a>
              <a 
                href="mailto:michaelfoto.contact@gmail.com" 
                className="flex items-center space-x-3 text-gray-400 hover:text-white transition-colors"
              >
                <Mail className="w-4 h-4 text-brand" />
                <span className="text-sm">michaelfoto.contact@gmail.com</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-white font-semibold text-lg">Πλατφόρμες</h3>
            <div className="space-y-2">
              {[
                { name: "TapG.gr", url: "https://tapg.gr" },
                { name: "RentMySite.gr", url: "https://rentmysite.gr" },
                { name: "Upplead.gr", url: "https://upplead.gr" }
              ].map((platform, index) => (
                <a
                  key={index}
                  href={platform.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-gray-400 hover:text-white transition-colors text-sm"
                >
                  <span>{platform.name}</span>
                  <ExternalLink className="w-3 h-3" />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-6 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-gray-500 text-sm">
            © {currentYear} Mike Foto. Με την επιφύλαξη παντός δικαιώματος.
          </p>
          <div className="flex space-x-6">
            <Link 
              to="/privacy" 
              className="text-gray-500 hover:text-white text-sm transition-colors"
            >
              Πολιτική Απορρήτου
            </Link>
            <Link 
              to="/terms" 
              className="text-gray-500 hover:text-white text-sm transition-colors"
            >
              Όροι Χρήσης
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
